import type {Pointer} from '@wix/document-services-types'
import type {CreateExtArgs} from '@wix/document-manager-core'
import type {DataModelExtensionAPI} from '../../../dataModel/dataModel'
import type {PlatformExtensionAPI} from '../../../platform'
import {DATA_TYPES} from '../../../../constants/constants'

const removePlatformApplicationFromPageIfLastAppWidget = (
    {pointers, extensionAPI}: CreateExtArgs,
    widgetRef: Pointer
) => {
    const {platform} = extensionAPI as PlatformExtensionAPI
    const {dataModel} = extensionAPI as DataModelExtensionAPI
    const widgetPageRef = pointers.structure.getPageOfComponent(widgetRef)

    if (!widgetPageRef) {
        return
    }

    const {applicationId} = dataModel.components.getItem(widgetRef, DATA_TYPES.data)
    const appWidgetsInPage = pointers.data.getDataItemsWithPredicate({applicationId}, widgetPageRef.id)

    platform.pagesPlatformApplication.updatePagePlatformApp(widgetPageRef, applicationId, appWidgetsInPage.length > 1)
}

const removeControllerFromStateMap = ({dal, pointers}: CreateExtArgs, widgetRef: Pointer) => {
    const controllerStatePointer = pointers.platform.getControllerStatePointer(widgetRef.id)

    if (dal.has(controllerStatePointer)) {
        dal.remove(controllerStatePointer)
    }
}

export const handleAppWidgetDeletion = (createExtArgs: CreateExtArgs, widgetRef: Pointer): void => {
    removePlatformApplicationFromPageIfLastAppWidget(createExtArgs, widgetRef)
    removeControllerFromStateMap(createExtArgs, widgetRef)
}
